import { Component } from '@angular/core';

@Component({
	selector: 'app-auth-layout',
	templateUrl: './auth-layout.component.html',
	styleUrls: []
})
export class AuthLayoutComponent  {
	constructor() {}


}
